import React from 'react'
import { Card } from 'react-bootstrap';
import { BiTimeFive } from 'react-icons/bi';
import { BsGlobe } from 'react-icons/bs';
import { AiOutlineCalendar } from 'react-icons/ai';
import { FaRupeeSign } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Footer from '../../../Layout/Footer';
import Header from '../../../Layout/Header';
import taskimage from '../../../../assets/img/taskimg.png';

const BrowseAllTasks = () => {
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Browse Tasks </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Browse Tasks</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='browse-tasks'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='browse-tasks-title'>
                                <h3>Browse tasks</h3>
                                <p>Check out what tasks people want done near you right now...</p>
                            </div>
                            <div className='col-lg-12'>
                                <form className="search-form d-flex align-items-center justify-content-center" >
                                    <input type="text" name="query" placeholder="Search" title="Search" className='w-50' />
                                    <button type="submit" title="Search">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" className='search-icon searchlist-icon' fill="#fff" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                        </svg>
                                    </button>
                                </form>
                            </div>
                            <div className='browse-tasks-tasks'>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Link className='browse-task-link' to=''>
                                            <Card>
                                                <Card.Body>
                                                    <div className='tasks-title'>
                                                        <Card.Title>Audio Video Editing</Card.Title>
                                                        <h6 className='task-amount'><FaRupeeSign /> 60</h6>
                                                    </div>
                                                    <div className='card-text tasks-browser-border'>
                                                        <div className='row'>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browse pt-2'>
                                                                    <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Remote</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1'>
                                                                    <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                    <p>Thu, 2 Feb</p>
                                                                </div>
                                                                <div className='tasks-browse pt-1 mb-2'>
                                                                    <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                    <p>Morning</p>
                                                                </div>
                                                            </div>
                                                            <div className='col-lg-6'>
                                                                <div className='tasks-browser-img'>
                                                                    <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='card-text'>
                                                        <div className='task-time-browse'>
                                                            <h5><span style={{ color: "#7db343" }}>OPEN</span> .1 offer</h5>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default BrowseAllTasks;